import { render, staticRenderFns } from "./DialogHistoricoAlteracoes.vue?vue&type=template&id=4942e30e&scoped=true&lang=pug"
import script from "./DialogHistoricoAlteracoes.vue?vue&type=script&lang=js"
export * from "./DialogHistoricoAlteracoes.vue?vue&type=script&lang=js"
import style0 from "./DialogHistoricoAlteracoes.vue?vue&type=style&index=0&id=4942e30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4942e30e",
  null
  
)

export default component.exports